import { render, staticRenderFns } from "./addDirektur.vue?vue&type=template&id=7c53ee61&scoped=true&"
import script from "./addDirektur.vue?vue&type=script&lang=js&"
export * from "./addDirektur.vue?vue&type=script&lang=js&"
import style0 from "./addDirektur.vue?vue&type=style&index=0&id=7c53ee61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53ee61",
  null
  
)

export default component.exports